interface EmitLoad {
  (e: 'loading', value): void;
}

export const useHtmlLoading = (element: Ref<HTMLElement>, emit: EmitLoad) => {
  const loading = ref<boolean>(true);

  const addImgsLoadListeners = (imgs) => {
    imgs.forEach((img) => {
      img.addEventListener('load', handleImgLoaded);
    });
  };

  const removeImgsLoadListeners = (imgs) => {
    imgs.forEach((img) => {
      img.removeEventListener('load', handleImgLoaded);
    });
  };

  const handleImgLoaded = (e) => {
    const imgs = element.value.querySelectorAll('img');
    loading.value = Array.from(imgs).some((img) => !img.complete);
  };

  onMounted(() => {
    const imgs = element.value.querySelectorAll('img');
    if (imgs.length === 0) loading.value = false;
    addImgsLoadListeners(imgs);
  });

  onBeforeUnmount(() => {
    const imgs = element.value.querySelectorAll('img');
    removeImgsLoadListeners(imgs);
  });

  watch(
    () => loading.value,
    (value) => {
      emit('loading', value);
    }
  );
  emit('loading', loading.value);
  return {
    loading,
  };
};
